import { http } from "@/http";

export default {
  getUserInfo() {
    return http.get("/api/v1/auth/me");
  }
};
